import { GetWorkRefusalRequestsResponse } from 'api/laborerPortalAPI/workRefusalRequests'
import { CallAPIAction, Status } from 'api/types'
import { LIST_ITEMS_PER_PAGE } from 'common/constants'
import {
  convertWorkRefusalRequestFromResponse,
  WorkRefusalRequest,
} from 'common/utils/convertResponse/convertWorkRefusalRequestResponse'
import { getWorkRefusalRequests } from 'redux/actionCreators/laborerPortalAPI/workRefusalRequests'
import Actions from 'redux/actions'

type State = {
  params: {
    page: number
    perPage: number
  }
  requests: Array<WorkRefusalRequest>
} & Status

const initialState: State = {
  params: {
    page: 1,
    perPage: LIST_ITEMS_PER_PAGE,
  },
  requests: [],
  isLoading: false,
  success: false,
  fail: false,
}

export default (
  state: State = initialState,
  action: CallAPIAction<
    Actions.GET_LABORER_WORK_REFUSAL_REQUESTS_ASYNC,
    Actions.GET_LABORER_WORK_REFUSAL_REQUESTS_SUCCESS,
    Actions.GET_LABORER_WORK_REFUSAL_REQUESTS_FAIL,
    GetWorkRefusalRequestsResponse,
    {},
    {},
    ReturnType<typeof getWorkRefusalRequests>['payload']
  >,
): State => {
  switch (action.type) {
    case Actions.GET_LABORER_WORK_REFUSAL_REQUESTS_SUCCESS: {
      const { page = 1, perPage = LIST_ITEMS_PER_PAGE } = action.callAPIActionPayload.params
      return {
        ...state,
        ...action.status,
        params: { page, perPage },
        requests: action.payload.data.map(convertWorkRefusalRequestFromResponse),
      }
    }
    case Actions.GET_LABORER_WORK_REFUSAL_REQUESTS_ASYNC:
    case Actions.GET_LABORER_WORK_REFUSAL_REQUESTS_FAIL:
      return {
        ...state,
        ...action.status,
      }
    default:
      return state
  }
}
